/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Updating_TitleInputs */

const en_app_updating_title = /** @type {(inputs: App_Updating_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updating app`)
};

const pt_br2_app_updating_title = /** @type {(inputs: App_Updating_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizando o aplicativo`)
};

/**
* | output |
* | --- |
* | "Updating app" |
*
* @param {App_Updating_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const app_updating_title = /** @type {((inputs?: App_Updating_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Updating_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_app_updating_title(inputs)
	return pt_br2_app_updating_title(inputs)
});